module.exports = __webpack_public_path__ + "img/IMGP8626b.c7e35a2a.jpg";